import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgHide = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="m23.5 12.642-.002-.002-.002-.003c-.919-1.935-2.019-3.5-3.298-4.693L18.92 9.226c1.103 1.014 2.056 2.364 2.879 4.06-2.102 4.347-5.082 6.41-9.154 6.41-1.294 0-2.48-.209-3.562-.632l-1.38 1.38c1.476.711 3.12 1.07 4.942 1.07 4.85 0 8.463-2.536 10.854-7.577.195-.409.195-.883.003-1.295Zm-1.614-8.381-1.07-1.07a.203.203 0 0 0-.285 0l-2.947 2.944c-1.473-.714-3.118-1.072-4.94-1.072-4.85 0-8.462 2.536-10.854 7.577v.002a1.521 1.521 0 0 0 0 1.3c.918 1.935 2.019 3.5 3.298 4.695l-2.541 2.536a.203.203 0 0 0 0 .285l1.07 1.07a.203.203 0 0 0 .285 0L21.886 4.543a.2.2 0 0 0 0-.282ZM9.791 13.929a2.824 2.824 0 0 1 3.393-3.393l-3.393 3.393Zm4.655-4.655a4.444 4.444 0 0 0-5.917 5.917l-2.16 2.16c-1.102-1.015-2.056-2.365-2.878-4.06C5.595 8.944 8.575 6.88 12.644 6.88c1.295 0 2.48.21 3.563.633l-1.761 1.761Zm-1.903 6.84c-.161 0-.32-.013-.474-.04l-1.29 1.289a4.44 4.44 0 0 0 5.84-5.84l-1.288 1.288a2.829 2.829 0 0 1-2.788 3.303Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

const ForwardRef = forwardRef(SvgHide)
const Memo = memo(ForwardRef)
export default Memo
